import { render, staticRenderFns } from "./dashall.vue?vue&type=template&id=55bbc450&"
import script from "./dashall.vue?vue&type=script&lang=js&"
export * from "./dashall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports